module.exports = __webpack_public_path__ + "static/media/veneto-village-22.36c49f8b.jpg";